<template>
  <div class="loading-bar" :class="[`bg-${theme}`, {'active': visible}]">
    <div class="text text-center" v-html="message"></div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: "Loading..." },
    theme: { type: String, default: "primary" },
    visible: { type: Boolean, default: false },
  },
};
</script>